import { createTrackingFormatterRegistry } from "../../../../../services/tracking/formatters";

import type { AppsFiltersTrackingFormatterRegistry } from "./types";

export const filterTrackingRegistry: AppsFiltersTrackingFormatterRegistry = createTrackingFormatterRegistry();
